import React, { memo } from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";
import { useHistory } from "react-router-dom";

const NonCart = props => {
	const classes = useStyles();
	const { height } = props;
	const history = useHistory();

	return (
		<Grid classes={{ root: classes.root }} style={{ height: height }}>
			<Grid classes={{ root: classes.bodyPage }}>
				<Grid style={{ textAlign: "center" }}>
					<img src={Images.icNonCart} alt="icNonCart" />
					<Grid classes={{ root: classes.text }}>
						Bạn chưa chọn mua sản phẩm vào giỏ hàng
					</Grid>
				</Grid>
				<Grid style={{ display: "flex", justifyContent: "center" }}>
					<Grid
						classes={{ root: classes.btnBuy }}
						onClick={() => {
							history.push("/find_product");
						}}
					>
						Mua ngay
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default memo(NonCart);
